import { Box, ButtonBase } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_KEY } from '../i18n';
import { colors } from '../ui/tokens';

// Two-option EN | FR toggle; both choices are always visible.
export function LanguageSwitcher({ dark = false }) {
    const { i18n } = useTranslation();
    const current = i18n.language?.startsWith('fr') ? 'fr' : 'en';

    const choose = (lng) => {
        i18n.changeLanguage(lng);
        try {
            window.localStorage.setItem(LANGUAGE_KEY, lng);
        } catch (e) {
            // Storage blocked: the choice still applies for this visit.
        }
    };

    return (
        <Box role="group" aria-label="Language" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}>
            {['en', 'fr'].map((lng, i) => (
                <Box key={lng} sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    {i > 0 && <Box component="span" sx={{ color: dark ? colors.onDarkMuted : colors.line, mx: 0.25 }}>/</Box>}
                    <ButtonBase
                        onClick={() => choose(lng)}
                        aria-pressed={current === lng}
                        sx={{
                            px: 0.75,
                            py: 0.5,
                            borderRadius: 1,
                            fontSize: '0.85rem',
                            fontWeight: current === lng ? 700 : 500,
                            letterSpacing: '0.04em',
                            textTransform: 'uppercase',
                            color: current === lng
                                ? (dark ? colors.onDark : colors.ink)
                                : (dark ? colors.onDarkMuted : colors.muted),
                            '&:hover': { color: dark ? colors.onDark : colors.ink },
                        }}
                    >
                        {lng}
                    </ButtonBase>
                </Box>
            ))}
        </Box>
    );
}
